<template>
  <div>
    <div class="layout-container grid h-screen w-screen">
      <mobile-sidebar ref="mobileMenu" />
      <div class="lg:grid grid-cols-11">
        <div
          class="hidden lg:flex lg:col-span-3 xl:col-span-2 3xl:col-span-1 bg-slate-900 border-b border-slate-700 items-center"
        >
          <router-link to="/" class="flex items-center justify-start px-8 text-white">
            <new-logo />
          </router-link>
        </div>
        <div
          ref="x"
          class="z-10 py-3 w-full fixed lg:py-0 lg:static lg:col-span-8 xl:col-span-9 3xl:col-span-10 bg-slate-100 flex items-center justify-between px-8"
        >
          <div class="block lg:hidden text-left">
            <button
              class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
              aria-label="Open sidebar"
              @click="$refs.mobileMenu.showSidebar()"
            >
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
          <div><!-- breadcrumbs--></div>
          <div class="flex items-center">
            <Search
              v-if="
                $store.state.general.currentUserAccountDetails.role == 'Admin' ||
                $store.state.general.currentUserAccountDetails.role == 'Contributor'
              "
              class="w-full"
            />
            <router-link to="/contacts/calendar" class="text-gray-600 flex items-center mr-3 ml-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="h-6 w-6 text-slate-800"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                />
              </svg>
            </router-link>
            <router-link
              to="/inbox"
              class="relative group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
            >
              <svg
                class="h-6 w-6 text-slate-800"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <path d="M4 13h3l3 3h4l3 -3h3" />
              </svg>

              <div
                v-if="$store.state.general.currentUserAccountDetails.unreadMessages > 0"
                class="animate-bounce rounded-full p-1 text-xs text-white flex items-center justify-center bg-rose-600 absolute top-0 right-0 -mt-1 mr-1 border-2 border-slate-100 box-border"
              >
                {{ $store.state.general.currentUserAccountDetails.unreadMessages }}
              </div>
            </router-link>
            <router-link
              v-if="$store.state.general.currentUserAccountDetails?.featureFlags?.admin_checklist_ui"
              to="/tasks"
              class="relative group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:text-gray-900 focus:bg-gray-100 transition ease-in-out duration-150"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-slate-800" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M4 19v-2h2v-7q0-2.075 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062T12 2t1.063.438T13.5 3.5v.7q2 .5 3.25 2.113T18 10v7h2v2zm8 3q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22m-4-5h8v-7q0-1.65-1.175-2.825T12 6T9.175 7.175T8 10z"
                />
              </svg>

              <div
                v-if="$store.state.general.currentUserAccountDetails.incompleteTasks > 0"
                class="animate-bounce rounded-full p-1 text-xs text-white flex items-center justify-center bg-rose-600 absolute top-0 right-0 -mt-1 mr-1 border-2 border-slate-100 box-border"
              >
                {{ $store.state.general.currentUserAccountDetails.incompleteTasks }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="lg:grid grid-cols-11">
        <sidebar />
        <div class="lg:col-span-8 xl:col-span-9 3xl:col-span-10 flex flex-col overflow-y-scroll">
          <div class="flex-grow p-8">
            <div v-if="!hideRouteHeader" class="flex items-end justify-between route-header-section">
              <div class="flex items-center">
                <h1 v-if="routeHeader" class="mr-2 text-2xl font-semibold text-gray-900">
                  {{ routeHeader }}
                </h1>
                <Help v-if="showHelp()" class="mr-2" />
                <LoadingSpinner />
              </div>
              <div class="flex-grow text-right">
                <slot name="header"></slot>
              </div>
            </div>

            <div class="mt-6">
              <slot v-if="ready"></slot>
            </div>
          </div>
        </div>
      </div>

      <Alert ref="alert" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MobileSidebar from './MobileSidebar/index.vue';
import Sidebar from './Sidebar/index.vue';
import Alert from '../shared/Alert.vue';
import LoadingSpinner from '../shared/LoadingSpinner.vue';
import Search from '../shared/Search.vue';
import Help from '../shared/Help.vue';
import NewLogo from '../hummer/onboarding/Navbar/Logo.vue';

export default {
  name: 'Layout',
  components: {
    MobileSidebar,
    Sidebar,
    Alert,
    LoadingSpinner,
    Search,
    Help,
    NewLogo,
  },
  props: {
    agentView: {
      default: false,
      required: false,
      type: Boolean,
    },
    hideRouteHeader: {
      default: false,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      sidebar: true,
      ready: false,
    };
  },
  computed: {
    ...mapState({ accountDetails: state => state.general.currentUserAccountDetails }),
    routeHeader() {
      let header = '';
      if (this.$route.name.includes('Detail')) {
        header = this.$route.name.replace('Detail', '');
      } else if (this.$route.name.includes('New')) {
        header = this.$route.name.replace('New', '');
      } else if (this.$route.name.includes('Edit')) {
        header = this.$route.name.replace('Edit', '');
      } else if (this.$route.name.includes('Calendar')) {
        header = this.$route.name.replace('Calendar', '');
      } else if (this.$route.name === 'Humaniz University') {
        header = '';
      } else {
        header = this.$route.name;
      }
      return header;
    },
  },
  async mounted() {
    window.document.body.classList.add('lg:overflow-hidden');
  },
  async created() {
    await this.getUserDetails();
    await this.getTeamSetup();
    this.ready = true;
  },
  methods: {
    showHelp() {
      return ![
        'Dashboard',
        'Dashboard V2',
        'Settings',
        'Integrations',
        'CandidateNew',
        'CandidateEdit',
        'Scorecard',
        'Humaniz University',
        'Pipeline Reviews',
      ].includes(this.$route.name);
    },
    async getUserDetails() {
      await this.$store.dispatch('general/loadCurrentUserAccountDetails');

      if (this.accountDetails.role === 'Agent' && this.$route.path === '/dashboard') {
        await this.$router.push('/agents/onboarding');
      }

      if (this.accountDetails.role !== 'Agent' && this.accountDetails.isOnboardingCompleted === false) {
        if (this.accountDetails.featureFlags?.hummer) {
          await this.$router.push('/start');
        } else {
          await this.$router.push('/welcome');
        }
      }
    },
    async getTeamSetup() {
      const res = await fetch(`/api/setup/1`);
      const data = await res.json();
      this.$store.commit('general/setTeamSetupProgress', {
        teamSetupProgress: data.progress,
      });
    },
  },
};
</script>

<style>
.layout-container {
  grid-template-rows: 70px calc(100vh - 70px);
}
</style>
